/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export function handleSkuChange(e, setSelectedSku, setHasWine, setIsAddToCartEnabled, sortedData, selectedSku = {}, skuid = '', trackVaseSelector = () => {}, eventAction = '') {
    const submitSlectedSku = sortedData.find((sku) => sku.id === (e?.target?.value || skuid || selectedSku.id));
    trackVaseSelector(eventAction, submitSlectedSku.code);
    setSelectedSku(submitSlectedSku);
    setHasWine(submitSlectedSku.ageVerifyFlag === 'true');
    setIsAddToCartEnabled(!(submitSlectedSku.ageVerifyFlag === 'true'));
}

export function triggerSubscriptionCheck(event, setSubscription, subscription, newValue) {
    setSubscription({ ...subscription, subscriptionCheckbox: newValue });
}

export function handlePersonalizeInputChange(valueCount, setDisableAddToCart) {
    if (valueCount === 0) {
        setDisableAddToCart(true);
    } else {
        setDisableAddToCart(false);
    }
}

export function getUpdatedPersonalizedProdData(setPersonalizedData, personalizedData) {
    if (personalizedData) {
        setPersonalizedData(personalizedData);
    }
}

export function handleMiniCartModalClick(minicartModalOpen, setMinicartModalOpen, setModal) {
    if (minicartModalOpen !== setModal) {
        setMinicartModalOpen(setModal);
    }
}

export function handleMobileAgeVerification(setMobileAgeVerificationOpen, setAddToCartData, addToCartData = null, flag) {
    setMobileAgeVerificationOpen(flag);
    setAddToCartData(addToCartData);
}

export function plantsCareData(careData) {
    const plantsCare = [
        {
            id: 'care_tips_light',
            label: 'Sunlight',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltea871d062b25d11c/63764c502f1aba10d25a9ebd/sunlight2x.png',
            style: { maxHeight: 52, maxWidth: 52 },
        },
        {
            id: 'care_tips_water',
            label: 'Water',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt581f2e758981e960/63764c7097ed2210a4d5358a/water2x.png',
            style: { maxHeight: 52, maxWidth: 38 },
        },
        {
            id: 'care_tips_temperature',
            label: 'Temperature',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blta853aea987a64280/63764c8e0d85671097f17714/temperature2x.png',
            style: { maxHeight: 52, maxWidth: 19 },
        },
        {
            id: 'care_tips_friendliness',
            label: 'Pet Friendly',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt2c34308c56bf728b/63764ca614868d10af0dd023/petfriendly2x.png',
            style: { maxHeight: 52, maxWidth: 41 },
        },
    ];
    careData.attributes.filter((item) => plantsCare.some((care, index) => {
        if (care.id === item.name) {
            plantsCare[index].description = item.values[0].value;
            return true;
        }
        return false;
    }));
    const finalCare = plantsCare.filter((item) => item.description);
    return finalCare;
}

export function weatherArray(careData) {
    const plantsCare = [
        {
            id: 'care_tips_light',
            label: 'Sunlight',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltea871d062b25d11c/63764c502f1aba10d25a9ebd/sunlight2x.png',
            style: { maxHeight: 52, maxWidth: 52 },
        },
        {
            id: 'care_tips_water',
            label: 'Water',
            description: '',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt581f2e758981e960/63764c7097ed2210a4d5358a/water2x.png',
            style: { maxHeight: 52, maxWidth: 38 },
        },
    ];
    careData.attributes.filter((item) => plantsCare.some((care, index) => {
        if (care.id === item.name) {
            plantsCare[index].description = item.values[0].value;
            return true;
        }
        return false;
    }));
    const showSizeChart = careData.attributes.filter(({ name }) => name === 'plant_size');
    const finalCare = plantsCare.filter((item) => item.description);
    return { finalCare, showSizeChart };
}

export const handleVaseClick = (skuid, commonStates, trackVaseSelector) => {
    const {
        selectedSku, setSelectedSku, setHasWine, setIsAddToCartEnabled, sortedData,
    } = commonStates;
    handleSkuChange('', setSelectedSku, setHasWine, setIsAddToCartEnabled, sortedData, selectedSku, skuid, trackVaseSelector, 'Planter Selection');
};

/**
 * Extract the vase code from variant id
 * @param {String} code - variant id
 * @returns {String} - vase code
 */

export const extractVaseCode = (code) => {
    if (!code) return null;
    const vaseCode = code.substring(12);
    const startsWithNumber = vaseCode.match(/^\d+/); // Check if the first char is number
    if (startsWithNumber) {
        const firstWordLength = startsWithNumber[0].length; // Remove if first char is number
        const modifiedString = vaseCode.slice(firstWordLength);
        return modifiedString;
    }
    return vaseCode;
};

/**
 * Return the active vases
 * @param {String} size - The active size Small | Medium | Large
 * @param {String} skuid - The skuid
 * @param {String} variantSize - The variant size S | M | L
 * @param {Array} vaseList - Vase List
 * @param {Array} variantList - List of variants
 * @param {String} commonStates - All the states
 * @param {Function} trackVaseSelector - A function to push event in Tealium
 * @param {String} plaSku - PLA Sku ID
 * @returns active vases
 */
export const renderVase = (size, skuid, variantSize, vaseList, variantList, commonStates, trackVaseSelector, plaSku = '') => {
    const {
        setVariantVaseList, selectedSku, setSelectedSku, setHasWine, setIsAddToCartEnabled, sortedData, setActiveVariant,
    } = commonStates;
    if (!vaseList || !variantList) return;
    setActiveVariant(size);
    handleSkuChange('', setSelectedSku, setHasWine, setIsAddToCartEnabled, sortedData, selectedSku, skuid, trackVaseSelector, 'Size Selection');
    const currentVases = variantList.filter((item) => item.id[11] === variantSize);
    let matchedItems = vaseList
        .filter((item) => currentVases.some((variant) => item.code === extractVaseCode(variant.id)))
        .map((item) => {
            const matchedVases = currentVases.find((variant) => item.code === extractVaseCode(variant.id));
            return {  ...item, ...matchedVases };
        });
    matchedItems = matchedItems
        .filter((item) => item.id[11] === variantSize)
        .sort((a, b) => a.variant_sort_order - b.variant_sort_order);
    if (!matchedItems.length) return;
    const index = matchedItems.findIndex((item) => item.id === plaSku);
    setSelectedSku(plaSku && index >= 0 ? matchedItems[index] : matchedItems[0]);
    setVariantVaseList(matchedItems);
};
